import {PayloadAction} from '@reduxjs/toolkit';
import smartCreativeBaseReducer from './smartCreativeBase/smartCreativeBase.slice';
import {SmartCreativeBaseState} from './smartCreativeBase/smartCreativeBase.types';

export type SmartCreativePageState = SmartCreativeBaseState;

const smartCreativePageReducer = (
  state: SmartCreativePageState,
  action: PayloadAction,
): SmartCreativePageState => {
  return smartCreativeBaseReducer(state, action);
};

export default smartCreativePageReducer;
